import { useEffect, useState } from 'react';


const MobileModule = () => {
  const [MobileApp, setMobileApp] = useState(null);
  useEffect(() => {
    import('mobile/Module').then((mod) => {
      setMobileApp(() => mod.default);
    });
  }, []);

  return MobileApp ? <MobileApp /> : null;
};

export default MobileModule;
